import { CRUDEntity } from "../abstracts/CRUDEntity";

export class QuickbooksIntegrationSettings extends CRUDEntity {
    constructor(id=null){
        super();
        this.entityClass = 'quickbooks-settings';
        this.urlRoot = '/quickbooks-integration';
        this.sectionRootUrl = '/quickbooks-integration';
        this.id = id;
    }
}